/* eslint-disable react/jsx-no-comment-textnodes */
import { useEffect, useRef, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { IoIosClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CountStockIcon from "../../assets/icons/CountStock.svg";
import OrderPickingIcon from "../../assets/icons/OrderPicking.svg";
import Downarrow from "../../assets/icons/downarrow.svg";
import smallDownArrow from "../../assets/icons/DownArrowOption.svg";
import DelIcon from "../../assets/icons/DeleteIconCircle.svg";
import MinusCircleIcon from "../../assets/icons/minus-circle-icon.svg";
import PlusCircleIcon from "../../assets/icons/plus-circle-icon.svg";
import productIconOrder from "../../assets/icons/product-icon-order.svg";
import searchIcon from "../../assets/icons/search.svg";
import Header from "../../layouts/Header";
import calendar from "../../assets/icons/Calendar3.svg";
import {
  DeleteProductPartStock,
  ProductDropdown,
  UpdateCountStock,
  UpdateProductDropdown,
  UpdateProductPartStock,
  fetchTranslationData,
} from "../../redux/actions/action";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import "../../assets/styles/local/CountStock.css";

import { Image } from "react-bootstrap";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
import Package from "../../assets/icons/package.svg";
import AppDatePicker from "../Common/AppDatePicker";
import {
  FETCH_PRODUCT_DROPDOWN,
  UPDATE_COUNT_STOCK,
} from "../../redux/constants/type";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import RouteLeavingGuard from "../Common/RouteLeavingGuard";
import CancelWarningModal from "../Dailogs/CancelWarningModal";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { SyncOutlined } from "@ant-design/icons";

const CountStockSingle = () => {
  const history = useHistory();
  const screenSize = useScreenSize();
  const [coverImage, setCoverImage] = useState("");
  const [row, setRow] = useState("");
  const [bin, setBin] = useState("");
  const [popups, setPopups] = useState(false);
  const [aisle, setAisle] = useState("");

  const handleCancel = () => {
    if (touched) {
      setPopups(true);
    } else {
      history.push("/stock");
    }
  };

  const [showLoader, setShowLoader] = useState(true);

  const [touched, setTouched] = useState(false);
  const [single, setSingle] = useState(true);
  const [list, setList] = useState(false);
  const [openStock, setOpenStock] = useState(false);
  const dispatch = useDispatch();

  const fetchProductDropdownData = useSelector(
    (state) => state.user.fetchProductDropdown,
  );
  const updateProductPartStock = useSelector(
    (state) => state.user.updateProductPartStock,
  );
  const updateCountStock = useSelector((state) => state.user.updateCountStock);
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const myAppName = localStorage.getItem("myAppName");
  const isOrderPicking = myAppName === "orderpicking";

  const handleProductPartSupplierStockChange = (
    stock,
    productPartSupplierid,
  ) => {
    stock = stock.replace(/\./g, "");
    stock = Number(stock.replace(/,/g, ""));
    if (stock >= 0) {
      dispatch(UpdateProductDropdown({ stock, productPartSupplierid }));
    }
  };
  const handleProductPartSupplierStockIncrease = (
    stock,
    productPartSupplierid,
  ) => {
    if (stock >= 0) {
      dispatch(
        UpdateProductDropdown({ stock: stock + 1, productPartSupplierid }),
      );
    }
  };

  const handleProductPartSupplierStockDecrease = (
    stock,
    productPartSupplierid,
  ) => {
    if (stock > 0) {
      dispatch(
        UpdateProductDropdown({ stock: stock - 1, productPartSupplierid }),
      );
    }
  };
  const handleNextClick = () => {
    if (productTableData.length > productIndex) {
      const selectItem = productTableData[productIndex + 1];
      if (selectItem) {
        const updatedData = productTableData?.map((item) => {
          return item.productPartid === selectItem.productPartid
            ? { ...item, isChecked: !item.isChecked }
            : { ...item, isChecked: false };
        });
        const dataToSet = updatedData.sort((a, b) => {
          const nameA = a.productPartName.toLowerCase().trim();
          const nameB = b.productPartName.toLowerCase().trim();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        setProductTableData(dataToSet);
        setsSelectedProduct(selectItem.productPartName);
        setProductIndex(productIndex + 1);
        setShowProductDrop(false);
        setCoverImage(selectItem.cover);
        setRow(selectItem.row);
        setAisle(selectItem.aisle);
        setBin(selectItem.bin);
      }
    }
    setTouched(true);
  };
  const [productTableData, setProductTableData] = useState([]);
  useEffect(() => {
    if (fetchProductDropdownData != null) {
      if (fetchProductDropdownData?.status) {
        const dataToSet = fetchProductDropdownData?.data?.sort((a, b) => {
          const nameA = a.productPartName.toLowerCase().trim();
          const nameB = b.productPartName.toLowerCase().trim();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        setProductTableData(dataToSet);
        setShowLoader(false);
      }
    }
  }, [fetchProductDropdownData]);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );
  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);
  const [searchItems, setSearchItems] = useState("");

  useEffect(() => {
    if (searchItems.trim() !== "") {
      if (fetchProductDropdownData != null) {
        if (fetchProductDropdownData?.status) {
          const originalData = fetchProductDropdownData?.data || [];

          const dataToSet = originalData?.filter(
            (name) =>
              name.productPartCode
                .toLowerCase()
                .includes(searchItems.toLowerCase()) ||
              name.productPartName
                .toLowerCase()
                .includes(searchItems.toLowerCase()) ||
              name.itemdescription
                .toLowerCase()
                .includes(searchItems.toLowerCase()) ||
              // supplier name and item id searching
              name.supplier?.some(
                (supplier) =>
                  supplier.productpartcode
                    ?.toLowerCase()
                    .includes(searchItems.toLowerCase()) ||
                  supplier.suppliername
                    ?.toLowerCase()
                    .includes(searchItems.toLowerCase()) ||
                  supplier.itemid
                    ?.toLowerCase()
                    .includes(searchItems.toLowerCase()),
              ),
          );
          setProductTableData(dataToSet);
        }
      }
    } else {
      if (fetchProductDropdownData != null) {
        if (fetchProductDropdownData?.status) {
          const dataToSet = fetchProductDropdownData?.data.sort((a, b) => {
            const nameA = a.productPartName.toLowerCase().trim();
            const nameB = b.productPartName.toLowerCase().trim();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          setProductTableData(dataToSet);
        }
      }
    }
  }, [searchItems, fetchProductDropdownData]);

  useEffect(() => {
    dispatch(ProductDropdown());
  }, []);

  useEffect(() => {
    if (
      updateProductPartStock?.status === true ||
      updateCountStock?.status === true
    ) {
      if (screenSize === "xs" || isOrderPicking) {
        setsSelectedProductMobile();
      } else {
        // history.push("/stock");
        setsSelectedProduct(null);
        setProductBottomTableData([]);
        setCoverImage("");
        setRow("");
        setAisle("");
        setBin("");
        handleGeneralNotification(
          { notificationType: "CUSTOM", text: "Count stock added." },
          false,
        );
        setProductTableData([]);
        dispatch({
          type: UPDATE_COUNT_STOCK,
          data: {},
        });
        dispatch({
          type: FETCH_PRODUCT_DROPDOWN,
          data: {},
        });
        dispatch(ProductDropdown());
      }
    }
    return () => {
      dispatch(DeleteProductPartStock());
    };
  }, [updateProductPartStock, updateCountStock]);

  const handleStockChange = () => {
    // const stock = [];
    // fetchProductDropdownData.data.forEach((product) => {
    //   product.suppliers.forEach((supplier) => {
    //     stock.push({
    //       productpartsupplierid: supplier.productPartSupplierid,
    //       instock: supplier.instock,
    //     });
    //   });
    // });
    // dispatch(UpdateProductPartStock(stock));
    const payload = [
      {
        dateOfCount: productBottomTableData.dateOfCount,
        qtyCount: productBottomTableData.qtyCount,
        productPartId: productBottomTableData.productPartid,
      },
    ];

    dispatch(UpdateCountStock(payload));
  };
  const handleCheckboxChange = (selectItem) => {
    const updatedData = fetchProductDropdownData?.data?.map((item) => {
      return item.productPartid === selectItem.productPartid
        ? { ...item, isChecked: !item.isChecked }
        : { ...item, isChecked: false };
    });
    const dataToSet = updatedData.sort((a, b) => {
      const nameA = a.productPartName.toLowerCase().trim();
      const nameB = b.productPartName.toLowerCase().trim();

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    updatedData.forEach((item, index) => {
      if (item.productPartid === selectItem.productPartid) {
        setProductIndex(index);
      }
    });
    setSearchItems("");
    setProductTableData(dataToSet);
    setsSelectedProduct(selectItem.productPartName);
    setShowProductDrop(false);
    setCoverImage(selectItem.cover);
    setRow(selectItem.row);
    setAisle(selectItem.aisle);
    setBin(selectItem.bin);
  };

  const [productBottomTableData, setProductBottomTableData] = useState([]);
  const [showProductDrop, setShowProductDrop] = useState(false);
  const [selectedProduct, setsSelectedProduct] = useState(null);
  const [productIndex, setProductIndex] = useState(-1);

  useEffect(() => {
    if (productIndex !== -1) {
      const productToUpdate = productTableData[productIndex];
      const updatedProduct = {
        ...productToUpdate,
        qtyCount: productToUpdate?.instock,
        dateOfCount: new Date(),
      };
      setProductBottomTableData(updatedProduct);
    }
  }, [productTableData, productIndex]);

  function formatEuropeanNumber(number) {
    const numericValue = parseFloat(number);

    if (!isNaN(numericValue)) {
      return numericValue.toLocaleString("en-EU")?.replace(",", ".");
    }
    return number;
  }

  //// ASC CLOSE DROP DOWN  CLICK OUT SIDE START /////
  const type_supplier_Drop_Ref = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      type_supplier_Drop_Ref.current &&
      !type_supplier_Drop_Ref.current.contains(event.target)
    ) {
      setShowProductDrop(false);
    }
  };
  const [selectedProductMobile, setsSelectedProductMobile] = useState();

  const refTypeDropDownContainer3 = useRef();
  const refTypeDropDownContainer3Exclude = useRef();
  const handleMouseDowTypeDD = (event) => {
    if (
      refTypeDropDownContainer3.current &&
      !refTypeDropDownContainer3.current.contains(event.target) &&
      !refTypeDropDownContainer3Exclude.current.contains(event.target)
    ) {
      setShowProductDrop(false);
    }
  };
  useEffect(() => {
    window.addEventListener("mousedown", handleMouseDowTypeDD);

    return () => {
      window.removeEventListener("mousedown", handleMouseDowTypeDD);
    };
  }, []);

  //// ASC CLOSE DROP DOWN  CLICK OUT SIDE END /////

  useEffect(() => {
    fetchScreenTranslations("Stock Levels").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  if (
    (screenSize === "xs" || isOrderPicking) &&
    selectedProductMobile &&
    selectedProductMobile?.productPartid &&
    selectedProductMobile?.productPartid !== ""
  ) {
    return (
      <>
        <Header />
        <div className="container-fluid">
          <div className=" main-wrapper mb-4">
            <div className="OrderPicking-outer">
              <div
                style={{
                  display: "flex",
                  // gap: "10px",
                  // justifyContent: "space-between",
                }}
              >
                <div
                  style={{ display: "flex", gap: "1px" }}
                  onClick={() => {
                    history.push("/stock");
                  }}
                >
                  <div
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1.1rem",
                      marginTop: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    {/* Stock */}
                    {t("Stock")}
                  </div>
                  <img
                    alt=""
                    src={Downarrow}
                    style={{
                      opacity: "60%",
                      marginTop: "18px",
                      marginBottom: "15px",
                      width: "15px",
                      height: "12px",
                      transform: "rotate(90deg)",
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div
                  style={{ display: "flex", gap: "5px", marginRight: "20px" }}
                >
                  <img
                    alt=""
                    src={OrderPickingIcon}
                    style={{
                      opacity: "60%",
                      marginTop: "12px",
                      marginBottom: "15px",
                      width: "15px",
                      height: "24px",
                      transform: "rotate(0deg)",
                      cursor: "pointer",
                    }}
                  />
                  <div
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1.1rem",
                      marginTop: "11px",
                      marginBottom: "15px",
                    }}
                  >
                    {/* Count Stock */}
                    {t("Stock Levels")}
                  </div>
                </div>
              </div>

              <div className={`${"order-picking-content-mobile"}`}>
                <div className="row">
                  <div className="p-0 col-xl-8">
                    <div
                      className="list-Of-Field"
                      style={{ position: "relative", paddingBottom: "110px" }}
                    >
                      <div className={"choose-project-dropdown-mobile"}>
                        <div
                          className={
                            "project-drop-view-mobile d-flex justify-content-between p-0"
                          }
                        >
                          <img
                            alt="BarCode"
                            style={{ width: "100%", height: "80px" }}
                            src={productBottomTableData.barCode}
                          />
                        </div>
                      </div>
                      <div>
                        <p style={{ marginTop: "30px", textAlign: "center" }}>
                          {selectedProduct}
                        </p>
                      </div>

                      <div>
                        <div
                          style={{
                            marginBottom: "20px",
                            width: "100%",
                            height: "40px",
                            border: "1px solid rgba(0, 0, 0, 0.3)",
                            borderRadius: "5px",
                            position: "relative",
                          }}
                        >
                          <label
                            style={{
                              whiteSpace: "nowrap",
                              position: "absolute",
                              top: "-10px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              background: "#fff",
                              padding: "0 5px",
                              color: "rgba(0, 0, 0, 0.5)",
                              fontSize: "10px",
                            }}
                          >
                            Internal ID
                          </label>

                          <div
                            className="order-table-output"
                            style={{
                              display: "flex",
                              height: "40px",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "12px",
                            }}
                          >
                            {productBottomTableData?.productPartCode}
                          </div>
                        </div>
                        {/* {productBottomTableData?.map((product, index) => {
                          return ( */}
                        <div className="justify-content-around  my-4">
                          <div
                            className="d-flex flex-wrap mb-3 w-100 align-items-center justify-content-center"
                            style={{ gap: "20px" }}
                          >
                            <div
                              style={{
                                width: "80px",
                                height: "40px",
                                border: "1px solid rgba(0, 0, 0, 0.3)",
                                borderRadius: "5px",
                                position: "relative",
                              }}
                            >
                              <label
                                style={{
                                  position: "absolute",
                                  top: "-10px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  background: "#fff",
                                  padding: "0 5px",
                                  color: "rgba(0, 0, 0, 0.5)",
                                  fontSize: "10px",
                                }}
                              >
                                {/* Color */}
                                {t("Color")}
                              </label>

                              <div
                                className="order-table-output"
                                style={{
                                  display: "flex",
                                  height: "40px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {productBottomTableData.color !== null ? (
                                  <span
                                    className="color-circle-order"
                                    style={{
                                      backgroundColor: `${productBottomTableData.color}`,
                                    }}
                                  ></span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>

                            <div className=" d-flex">
                              <img
                                src={MinusCircleIcon}
                                className="MinusCircleIcon"
                                alt=""
                                onClick={() => {
                                  setProductBottomTableData((prevData) => ({
                                    ...prevData,
                                    qtyCount:
                                      productBottomTableData.qtyCount - 1,
                                  }));
                                }}
                                // onClick={() =>
                                //   handleProductPartSupplierStockDecrease(
                                //     productBottomTableData.instock,
                                //     productBottomTableData.productPartSupplierid
                                //   )
                                // }
                              />
                              <div
                                className="order-table-output"
                                style={{
                                  width: "100%",
                                  paddingLeft: "20px",
                                  paddingRight: "20px",
                                  position: "relative",
                                }}
                              >
                                <label
                                  style={{
                                    fontSize: "12px",
                                    position: "absolute",
                                    top: "-10px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    background: "#fff",
                                    padding: "0 5px",
                                    color: "rgba(0, 0, 0, 0.5)",
                                  }}
                                >
                                  Qty Counted
                                </label>
                                <input
                                  style={{
                                    border: "1px solid rgba(0, 0, 0, 0.3)",
                                    borderRadius: "5px",
                                    width: "100%",
                                  }}
                                  value={productBottomTableData.qtyCount}
                                  // value={formatEuropeanNumber(productBottomTableData.instock)}
                                  type="text"
                                  // onChange={(e) =>
                                  //   handleProductPartSupplierStockChange(
                                  //     e.target.value,
                                  //     productBottomTableData.productPartSupplierid
                                  //   )
                                  // }
                                  onChange={(e) => {
                                    setTouched(true);
                                    const newQtyCount = e.target.value;
                                    setProductBottomTableData((prevData) => ({
                                      ...prevData,
                                      qtyCount: newQtyCount,
                                    }));
                                  }}
                                />
                              </div>

                              <img
                                src={PlusCircleIcon}
                                className="PlusCircleIcon"
                                alt=""
                                onClick={() => {
                                  setProductBottomTableData((prevData) => ({
                                    ...prevData,
                                    qtyCount:
                                      productBottomTableData.qtyCount + 1,
                                  }));
                                }}
                                // onClick={() =>
                                //   handleProductPartSupplierStockIncrease(
                                //     productBottomTableData.instock,
                                //     productBottomTableData.productPartSupplierid
                                //   )
                                // }
                              />
                            </div>
                          </div>
                        </div>
                        {/* //   );
                        // })} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            position: "fixed",
            bottom: "0",
            width: "100%",
            background: "#fafafa",
          }}
        >
          <div style={{ width: "100%", padding: "20px" }}>
            <button
              style={{ width: "100%" }}
              className="worktime-cancel-btn"
              onClick={() => setsSelectedProductMobile()}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>
            <button
              onClick={handleNextClick}
              style={{ width: "100%", marginTop: "7px" }}
              className="worktime-cancel-btn"
              disabled={productTableData.length === productIndex + 1}
            >
              {/* Next */}
              {t("Next")}
            </button>

            <button
              style={{ width: "100%", marginTop: "7px" }}
              className="worktime-add-btn frc"
              disabled={!selectedProduct}
              onClick={handleStockChange}
            >
              {/* <p>Add </p> */}
              <p>{t("Add")} </p>
            </button>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <Header
        leftComponent={
          <div
            className="stock-heading-box"
            style={{ alignItems: "flex-start" }}
          >
            <div
              className="stock-heading cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <div>
              <div
                className="box-title d-flex flex-column position-relative product_stock_entry_title_report pointer"
                style={{
                  border: "0.5px solid #e0dada",
                  borderRadius: "8px",
                  height: "50px",
                }}
                onClick={() => setOpenStock(!openStock)}
              >
                <div className="d-flex justify-content-between w-100 align-items-center">
                  <span>{t("Stock Levels - Entry")}</span>
                  <img
                    alt=""
                    src={smallDownArrow}
                    style={{
                      opacity: "60%",
                      width: "16px",
                      height: "14px",
                      transform: openStock ? "rotate(180deg)" : "rotate(0deg)",
                      cursor: "pointer",
                    }}
                  />
                </div>
                {openStock && (
                  <span
                    style={{
                      top: "50px",
                      left: "0",
                      border: "0.5px solid #e0dada",
                      borderRadius: "8px",
                    }}
                    className="box-title align-self-start cursor-pointer  font-weight-normal position-absolute product_stock_entry_title_report"
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push("/stock-levels-report");
                    }}
                  >
                    {t("Stock Levels - Report")}
                  </span>
                )}
              </div>
            </div>
            <div className="d-flex mainSwitch ms-5 pointer">
              <div
                className={
                  single ? "singleSwitch px-4 py-1" : "noSwitch px-4 py-1"
                }
                onClick={() => {
                  setSingle(true);
                  setList(false);
                  history.push("/stock-levels-single");
                }}
              >
                {/* Single */}
                {t("Single")}
              </div>
              <div
                className={list ? "listSwitch px-4 py-1" : "noSwitch px-4 py-1"}
                onClick={() => {
                  setList(true);
                  setSingle(false);
                  history.push("/stock-levels-list");
                }}
              >
                {/* List */}
                {t("List")}
              </div>
            </div>
          </div>
        }
        // setQuery={setQuery}
      />
      <div className="container-fluid">
        <div className=" main-wrapper mb-4">
          <div
            className={screenSize !== "xs" && !isOrderPicking && "containerBox"}
          >
            {(screenSize === "xs" || isOrderPicking) && (
              <div
                style={{
                  display: "flex",
                  // gap: "10px",
                  // justifyContent: "space-between",
                }}
              >
                <div
                  style={{ display: "flex", gap: "1px" }}
                  onClick={() => {
                    history.push("/stock");
                  }}
                >
                  <div
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1.1rem",
                      marginTop: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    {/* Stock */}
                    {t("Stock")}
                  </div>
                  <img
                    alt=""
                    src={Downarrow}
                    style={{
                      opacity: "60%",
                      marginTop: "18px",
                      marginBottom: "15px",
                      width: "15px",
                      height: "12px",
                      transform: "rotate(90deg)",
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div
                  style={{ display: "flex", gap: "5px", marginRight: "20px" }}
                >
                  <img
                    alt=""
                    src={CountStockIcon}
                    style={{
                      marginTop: "12px",
                      marginBottom: "15px",
                      width: "25px",
                      height: "24px",
                      transform: "rotate(0deg)",
                      cursor: "pointer",
                    }}
                  />
                  <div
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1.1rem",
                      marginTop: "11px",
                      marginBottom: "15px",
                    }}
                  >
                    {/* Count Stock */}
                    {t("Stock Levels")}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div>
            {screenSize !== "xs" && !isOrderPicking && (
              <div>
                <div className="CountStock-action d-flex justify-content-end mb-4">
                  <button
                    className="cancel-btn"
                    onClick={() => history.push("/stock")}
                  >
                    {/* Cancel */}
                    {t("Cancel")}
                  </button>
                  <button
                    disabled={productTableData.length === productIndex + 1}
                    className="btn next-btn ms-3"
                    onClick={handleNextClick}
                  >
                    {/* Next */}
                    {t("Next")}
                  </button>
                  <button
                    className="add-btn ms-3"
                    disabled={!selectedProduct}
                    onClick={() => handleStockChange()}
                  >
                    {/* Add */}
                    {t("Add")}
                  </button>
                </div>
              </div>
            )}
            <div
              className={
                screenSize === "xs" || isOrderPicking
                  ? "CountStock-content-mobile"
                  : "CountStock-content"
              }
            >
              <div className="row justify-content-between">
                <div className="p-0 col-xl-7">
                  {screenSize === "xs" || isOrderPicking ? (
                    <div>
                      <div className="project-search-main-mobile">
                        <img
                          alt=""
                          className="search_pop ms-2 mb-1"
                          src={searchIcon}
                        />
                        <input
                          type="text"
                          value={searchItems}
                          style={{
                            margin: "0 0 0 0.5rem",
                            fontSie: "14px",
                          }}
                          placeholder={"Search"}
                          className="search-style select-client-div"
                          onChange={(e) => {
                            setSearchItems(e.target.value);
                            setTouched(true);
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      className="item-field"
                      style={{ position: "relative" }}
                    >
                      {screenSize !== "xs" && !isOrderPicking && (
                        <div
                          className="d-flex mb-3"
                          style={{ marginLeft: "-20px" }}
                        >
                          <img src={productIconOrder} alt="" />
                          <h5 className="item-label-heading">
                            {/* Item */}
                            {t("Item")}
                          </h5>
                        </div>
                      )}
                      <div className="choose-project-dropdown">
                        <div
                          className="project-drop-view d-flex justify-content-between"
                          ref={refTypeDropDownContainer3Exclude}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              width: "100%",
                            }}
                            onClick={() => setShowProductDrop(!showProductDrop)}
                          >
                            {(screenSize === "xs" || isOrderPicking) && (
                              <img
                                alt=""
                                className="search_pop ms-2 mb-1 mt-1"
                                src={searchIcon}
                              />
                            )}
                            <p className="margin-0-pop ps-2 color">
                              {/* {selectedProduct || (screenSize === "xs" ? "Search" : "Type or scan an item")} */}
                              {selectedProduct && selectedProduct.length > 50
                                ? `${selectedProduct.substring(0, 50)}...`
                                : selectedProduct ||
                                  (screenSize === "xs" || isOrderPicking
                                    ? t("Worktime")
                                    : t("Type or scan an item"))}
                            </p>
                          </div>
                          {selectedProduct && selectedProduct !== "" && (
                            <span
                              className="cross-icon"
                              onClick={() => {
                                setsSelectedProduct(null);
                                setProductBottomTableData([]);
                                setTouched(true);
                              }}
                            >
                              x
                            </span>
                          )}
                        </div>

                        {showProductDrop && (
                          <div
                            ref={refTypeDropDownContainer3}
                            className="add-item-wrapper order-picking-wrapper"
                          >
                            <div className="d-flex justify-content-between align-items-center bgdiv">
                              <p className="inputparts px-3">Parts</p>
                              <div className="add-item-title  w-100">
                                <input
                                  className="update-member-input-noborder add-member-input bgforinput w-100"
                                  value={searchItems}
                                  onChange={(e) => {
                                    setSearchItems(e.target.value);
                                    setTouched(true);
                                  }}
                                  placeholder={t("Search")}
                                />
                              </div>
                              <img
                                src={DelIcon}
                                alt=""
                                className="mx-3 cursor-pointer"
                                onClick={() => {
                                  setShowProductDrop(!showProductDrop);
                                  setSearchItems("");
                                  setTouched(true);
                                }}
                              />
                            </div>
                            <div className="border-line d-none"></div>
                            <div className="count-items-main gap-0 p-3">
                              {showLoader && (
                                <p className="text-center">
                                  please wait while we fetching your data...
                                  &nbsp; <SyncOutlined spin />
                                </p>
                              )}

                              {productTableData.map((items, index) => (
                                <div
                                  onClick={() => {
                                    handleCheckboxChange(items);
                                    setTouched(true);
                                  }}
                                  key={index}
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="missing-items add-item-title">
                                    <div
                                      className="count-title"
                                      style={{ width: "300px" }}
                                    >
                                      {items.productPartName}
                                    </div>

                                    {isBuildingBlock && (
                                      <div className="title-hover">
                                        <div className="items-desc-column4">
                                          <div className="desc-image-wrp4 desc-image4 ">
                                            {items?.cover ? (
                                              <>
                                                <div
                                                  className={`product-list-image-default4 ${
                                                    items?.image?.length === 0
                                                      ? "hover-hide4"
                                                      : ""
                                                  }`}
                                                >
                                                  <img
                                                    src={items?.cover}
                                                    alt=""
                                                    className="cover-image4"
                                                  />
                                                  {items?.image &&
                                                    items?.image?.length >
                                                      0 && (
                                                      <div className="image-row4">
                                                        {items?.image
                                                          .slice(0, 3)
                                                          .map((val, index) => (
                                                            <img
                                                              key={index}
                                                              src={val.image}
                                                              alt={`Images ${
                                                                index + 1
                                                              }`}
                                                            />
                                                          ))}
                                                      </div>
                                                    )}
                                                </div>
                                                {items?.image &&
                                                  items?.image?.length > 0 && (
                                                    <span className="desc-image-plus4">
                                                      <Image
                                                        height={10}
                                                        width={10}
                                                        src={plusBorderWhite}
                                                      />
                                                    </span>
                                                  )}
                                              </>
                                            ) : (
                                              <div className="product-list-default4">
                                                <img
                                                  src={Package}
                                                  alt=""
                                                  className="default-img4"
                                                />
                                                <div className="product-image-title d-none">
                                                  Picture
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <div className="count-col">
                                      <div>
                                        {/* Stock */}
                                        {t("Stock")}
                                      </div>
                                    </div>

                                    <div className="stock-count-items">
                                      <div className="stock-color">
                                        <div className="d-flex align-items-center gap-4 justify-content-center">
                                          {items.instock > 0 ? (
                                            <>
                                              <div className="d-flex flex-column align-items-center justify-content-center gap-1">
                                                <div
                                                  style={{
                                                    backgroundColor: `${items.color}`,
                                                  }}
                                                  className="color-code"
                                                ></div>
                                              </div>

                                              <div className="info-items">
                                                {items.instock}
                                              </div>
                                            </>
                                          ) : (
                                            <div className="empty-item">-</div>
                                          )}
                                        </div>
                                      </div>
                                      {/* <img
                                                                onClick={() => handleCheckboxChange(items, index)}
                                                                className="plus-img"
                                                                src={items.isChecked ? CheckboxBlueIcon : CheckboxIcon}
                                                                alt="check-item"
                                                            /> */}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {(screenSize === "xs" || isOrderPicking) && (
                    <>
                      <div className="project-lable d-flex mb-3 mt-4">
                        <h5
                          className="project-lable-heading"
                          style={{ color: "#323232" }}
                        >
                          Choose an item
                          {/* {FetchTranslationList[19]?.translation} */}
                        </h5>
                      </div>
                      {screenSize !== "xs" && !isOrderPicking && (
                        <div
                          className={
                            screenSize === "xs" || isOrderPicking
                              ? "choose-project-dropdown-mobile"
                              : "choose-project-dropdown"
                          }
                        >
                          <div
                            className={
                              screenSize === "xs" || isOrderPicking
                                ? "project-drop-view-mobile d-flex justify-content-between"
                                : "project-drop-view d-flex justify-content-between"
                            }
                          >
                            {screenSize !== "xs" && !isOrderPicking && (
                              <>
                                <p
                                  className="margin-0-pop  ps-2"
                                  onClick={() =>
                                    setShowProductDrop(!showProductDrop)
                                  }
                                >
                                  {/* {selectedProduct || "Type or scan an item"} */}
                                  {selectedProduct || t("Type or scan an item")}
                                </p>
                                <BsChevronDown
                                  size={18}
                                  onClick={() => {
                                    setShowProductDrop(!showProductDrop);
                                    setTouched(true);
                                  }}
                                  className={
                                    "down-arrow-pop bi-paperclip ms-4 ms-xxl-3"
                                  }
                                />
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  {(screenSize === "xs" || isOrderPicking) && (
                    <div style={{ marginTop: "20px" }}>
                      {productTableData?.map((item) => {
                        return (
                          <div
                            onClick={() => {
                              setsSelectedProductMobile(item);
                              handleCheckboxChange(item);
                              setTouched(true);
                            }}
                          >
                            <img
                              alt="BarCode list"
                              style={{ width: "100%", height: "80px" }}
                              src={item.barCode}
                            />
                            {/* <div className="d-flex justify-content-between gap-4 pe-4"> */}
                            <p
                              style={{
                                marginLeft: "20px",
                                width: "30%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "block",
                              }}
                            >
                              {/* {item?.productPartCode?.substring(0, 8)} */}
                            </p>
                            <p
                              style={{
                                width: "100%",
                                textAlign: "center",
                                fontSize: "18px",
                                color: "black",
                                wordWrap: "break-word",
                                overflow: "hidden",
                              }}
                            >
                              {item?.productPartName?.substring(0, 20)}
                            </p>
                            {/* </div> */}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {screenSize !== "xs" && !isOrderPicking && (
                    <div className="multiple-field">
                      <div className="row">
                        {/* Item ID */}
                        <div className="col-12 col-lg-3 col-md-6 pe-md-3 pe-1">
                          <h3 className="item-heading">{t("Item ID")}</h3>
                          {!selectedProduct && (
                            <div className="item">
                              <div className="item-output"></div>
                            </div>
                          )}
                        </div>
                        {/* Color */}
                        <div className="col-12 col-lg-2 col-md-6 p-0 pe-1">
                          <h3 className="item-heading">{t("Color")}</h3>
                          {!selectedProduct && (
                            <div className="item">
                              <div className="item-output"></div>
                            </div>
                          )}
                        </div>
                        {/* In Stock */}
                        <div className="col-12 col-lg-2 col-md-6 p-0 pe-3">
                          <h3 className="item-heading">{t("In Stock")}</h3>
                          {!selectedProduct && (
                            <div className="item">
                              <div className="item-output"></div>
                            </div>
                          )}
                        </div>
                        {/* Qty Counted*/}
                        <div className="col-12 col-lg-2 col-md-6 p-0 pe-1">
                          <h3 className="font-bold-qty item-heading ">
                            {t("Qty Counted")}
                          </h3>
                          {!selectedProduct && (
                            <div className="item">
                              <div className="item-output"></div>
                            </div>
                          )}
                        </div>
                        {/* Date of Count */}
                        <div className="col-12 col-lg-3 col-md-6 ps-0">
                          <h3 className="font-bold-qty item-heading">
                            {t("Date of Count")}
                          </h3>
                          {!selectedProduct && (
                            <div className="item">
                              <div className="item-output"></div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* {productBottomTableData?.map((item, index) => {
                    return ( */}
                  {selectedProduct &&
                    screenSize !== "xs" &&
                    !isOrderPicking && (
                      <div className="pb-1">
                        <div className="row">
                          {/* Item ID */}
                          <div className="col-12 col-lg-3 pe-1">
                            <div className="item">
                              <div className="item-output d-flex align-items-center justify-content-center">
                                {productBottomTableData.productPartCode}
                              </div>
                            </div>
                          </div>
                          {/* Color */}
                          <div className="col-12 col-lg-2 p-0 pe-1">
                            <div className="item">
                              <div
                                className="item-output"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  style={{
                                    width: "21.5px",
                                    height: "21.5px",
                                    backgroundColor:
                                      productBottomTableData.color,
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          {/* In Stock */}
                          <div className="col-12 col-lg-2 pe-3 p-0">
                            <div className="">
                              <div
                                className="item-output d-flex align-items-center justify-content-center"
                                style={{ width: "auto" }}
                              >
                                {productBottomTableData.instock}
                              </div>
                            </div>
                          </div>
                          {/* Qty Counted */}
                          <div className="col-12 col-lg-2 p-0 pe-1">
                            <div className="">
                              <input
                                className="item-output "
                                style={{ width: "-webkit-fill-available" }}
                                value={productBottomTableData.qtyCount}
                                type="number"
                                placeholder="0"
                                onChange={(e) => {
                                  setTouched(true);
                                  const newQtyCount = e.target.value;
                                  setProductBottomTableData((prevData) => ({
                                    ...prevData,
                                    qtyCount: newQtyCount,
                                  }));
                                }}
                              />
                            </div>
                          </div>
                          {/* Date of Count */}
                          <div className="col-12 col-lg-3 p-0 pe-1">
                            <div className="" style={{ width: "auto" }}>
                              <td
                                className="product-color-date item-output d-flex"
                                style={{ width: "auto" }}
                              >
                                <div className="stock-entry-input d-flex align-items-center">
                                  <img
                                    className="calendarIcon pointer"
                                    onClick={() => setCalendarIsOpen((p) => !p)}
                                    src={calendar}
                                    alt=""
                                  />
                                  <AppDatePicker
                                    open={calendarIsOpen}
                                    selected={
                                      productBottomTableData.dateOfCount
                                    }
                                    onChange={(e) => {
                                      setTouched(true);
                                      setCalendarIsOpen(false);
                                      setProductBottomTableData((prevData) => ({
                                        ...prevData,
                                        dateOfCount: e,
                                      }));
                                    }}
                                    onSelect={(d, event) => {
                                      event.preventDefault();
                                    }}
                                    dateFormat="dd/MM/yyyy"
                                  />
                                </div>
                              </td>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  {/* //   );
                  // })} */}
                </div>
                {/* <div className="col-xl-1"></div> */}
                {screenSize !== "xs" && !isOrderPicking && (
                  <div className="pe-0 col-xl-4">
                    {isBuildingBlock && (
                      <div className="mb-3">
                        <div className="project-lable d-flex mb-3">
                          <h5 className="project-count-heading">
                            {t("Product Image")}
                          </h5>
                        </div>
                        <div className="product-order-images">
                          {coverImage && <img src={coverImage} alt="" />}
                        </div>
                      </div>
                    )}
                    <div className="list-Of-Field">
                      <div className="project-lable d-flex mb-3">
                        <h5 className="project-count-heading">
                          {t("Locations Specifications")}
                        </h5>
                      </div>
                      <div className="count-order-wrp">
                        <div className="location-wrp">
                          <span>{aisle ? aisle : 0}</span>
                          <span>
                            {/* Aisle */}
                            {t("Aisle")}
                          </span>
                        </div>
                        <div className="location-wrp">
                          <span>{row ? row : 0}</span>
                          <span>
                            {/* Row */}
                            {t("Row")}
                          </span>
                        </div>
                        <div className="location-wrp">
                          <span>{bin ? bin : 0}</span>
                          <span>
                            {/* Bin */}
                            {t("Bin")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {popups && (
        <CancelWarningModal
          show={popups}
          onHide={() => setPopups(false)}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={touched}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (touched) {
            if (!["/stock"].includes(location.pathname)) {
              return true;
            }
          }
          return false;
        }}
      />
    </>
  );
};

export default CountStockSingle;
